<script lang="ts">
    import { navigate } from 'svelte-navigator';
    import type { Readable } from 'svelte/store';
    import { FormGroup, Label, Button, Card, CardBody, Container, Row, Col, InputGroup, InputGroupText, Icon, Alert } from 'sveltestrap';
    import Form from '../Components/Form.svelte';
    import Input from '../Components/Input.svelte';
    import Logo from '../Components/Logo.svelte';
    import { LOGIN_FAIL } from '../errors';
    import { loginService, sessionService } from '../Services';

    let userIdent: string = '';
    let userPassword: string = '';
    let rememberSession: boolean = false;
    let formValid: Readable<boolean>;
    let loginFail = false;
    let isLogging = false;

    async function onSubmit() {
        
        if (!$formValid) {
            return;
        }

        try {

            isLogging = true;
            const accessToken = await loginService.login(userIdent, userPassword);
            await sessionService.startSession(accessToken, rememberSession);
            navigate('/inicio');
        
        } catch (error) {
            console.error(error);

            loginFail = error.name === LOGIN_FAIL;

            if (!loginFail) {
                alert(`Ops! Parece que ha ocurrido un error desconocido al realizar el login.\nMesaje del error:\n${error.message}`);
            }
        
        } finally {
            isLogging = false;
        }
    }

</script>   

<Container>
    <Row>
        <Col class="text-center my-5">
            <Logo />
        </Col>
    </Row>
    <Row class="justify-content-center">
        <Col sm="12" md="8" lg="6" xl="4">
            <Card class="shadow-sm">
                <CardBody>
                    <Form on:submit={onSubmit} novalidate bind:valid={formValid}>

                        {#if loginFail}
                        <Alert color="warning">
                            <Icon name="exclamation-square" /> Parece que los datos de acceso no son correctos.
                        </Alert>
                        {/if}
                        
                        <FormGroup>
                            <Label>DNI o Email</Label>
                            <InputGroup>
                                <InputGroupText>
                                    <Icon name="person" />
                                </InputGroupText>
                                <Input
                                    type="text"
                                    disabled={isLogging}
                                    required
                                    bind:value={userIdent} />
                            </InputGroup>
                        </FormGroup>
                    
                        <FormGroup>
                            <Label>Contraseña</Label>
                            <InputGroup>
                                <InputGroupText>
                                    <Icon name="asterisk" />
                                </InputGroupText>
                                <Input
                                    type="password"
                                    disabled={isLogging}
                                    required
                                    minlength={5}
                                    bind:value={userPassword} />
                            </InputGroup>
                            
                        </FormGroup>

                        <Input type="checkbox" label="Recuerdame" bind:checked={rememberSession} />
                    
                        <Button type="submit" class="mt-3" color="primary" block disabled={isLogging}>
                            {isLogging ? 'Accediendo...' : 'Entrar'}
                        </Button>
                    
                    </Form>
                </CardBody>
            </Card>
        </Col>
    </Row>
</Container>


